import { Component } from '@angular/core';
import { AuthenticationService } from '@app/core/services';
import { Store } from '@ngrx/store';
import { selectIsAdmin, selectIsAuthenticated, selectIsSales } from '@app/core/store/auth/auth.selectors';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent {
  constructor(
    private authService: AuthenticationService,
    private store: Store
  ) { }

  navbarOpen = false;
  readonly isAuthenticated$: Observable<boolean> = this.store.select(selectIsAuthenticated);
  readonly isAdmin$: Observable<boolean> = this.store.select(selectIsAdmin);
  readonly isSales$: Observable<boolean> = this.store.select(selectIsSales);

  toggleNavbar(): void {
    this.navbarOpen = !this.navbarOpen;
  }

  logOut(): void {
    this.authService.logOut();
  }
}
